/* UPS Sizing Wizard — external mount logic.

   Loaded from layout/theme.liquid so it executes even when the section markup is

   injected via innerHTML (FR cache-recovery), where an inline <script> would be inert.

   Localized strings + config come from the section's

   <script type="application/json" data-upsb-rtc-config> block (data survives innerHTML).

   Idempotent + retried so it mounts whenever/however the section appears. */

(function () {

  // E.16: order groups (DECISIONS.md "Suggestion order"); a brand chosen in the dropdown or an explicit sort wins.

  var ORDER_A = ['Xtreme Power Conversion'];

  function vendorTier(v) { var i = ORDER_A.indexOf(v); return i < 0 ? ORDER_A.length : i; }

  // E.15: shared index cache. A mounted section can be replaced at any time (the FR
  // cache-recovery guard, theme editor, section rendering); a re-mount must not
  // re-download the ~530 KB index. Mounts never mutate the parsed object, so sharing
  // it across mounts is safe. A failed fetch is dropped from the cache so the retry
  // logic and any later mount can try again.

  var indexCache = {}; // url -> Promise<parsed json>

  function fetchIndexJson(indexUrl) {

    if (!indexCache[indexUrl]) {

      indexCache[indexUrl] = fetch(indexUrl).then(function (r) {

        if (!r.ok) throw new Error('HTTP ' + r.status);

        return r.json();

      }).catch(function (e) {

        delete indexCache[indexUrl];

        throw e;

      });

    }

    return indexCache[indexUrl];

  }

  function mount(root) {

    if (root.__rtcMounted) return;

    var cfgEl = root.querySelector('[data-upsb-rtc-config]');

    if (!cfgEl) return;

    var CFG;

    try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    root.__rtcMounted = true;



    var i18n = CFG.i18n || {};

    var indexUrl = CFG.indexUrl;

    var quoteBase = CFG.quoteBase || '/pages/request-a-quote';

    var rootUrl = CFG.rootUrl || '/';



    var $ = function (s) { return root.querySelector(s); };

    var $$ = function (s) { return root.querySelectorAll(s); };



    var state = {

      mode: 'simple', amount: parseFloat(($('[data-upsb-rtc-amount]') || {}).value) || 600,

      unit: 'W', powerFactor: 0.8, equipment: [], target: 10, efficiency: 92, batteryHealth: 100, ff: '', prot: '',

      volt: '120', voltAuto: true, cond: '', brand: '', sort: '',

      shown: 12, _keepShown: false, _keepBuilder: false, _view: 'cards'

    };

    var lastAll = [], lastLoad = 0;



    var modeTabs = $$('[data-upsb-rtc-mode]'), panes = $$('[data-upsb-rtc-pane]');

    var amountInput = $('[data-upsb-rtc-amount]'), unitSelect = $('[data-upsb-rtc-unit]');

    var pfRow = $('[data-upsb-rtc-pf-row]'), pfInput = $('[data-upsb-rtc-pf]'), pfDisplay = $('[data-upsb-rtc-pf-display]');

    var addName = $('[data-upsb-rtc-add-name]'), addWatts = $('[data-upsb-rtc-add-watts]'), addQty = $('[data-upsb-rtc-add-qty]'), addBtn = $('[data-upsb-rtc-add]');

    var equipmentList = $('[data-upsb-rtc-equipment-list]'), detailedTotal = $('[data-upsb-rtc-detailed-total]'), detailedWatts = $('[data-upsb-rtc-detailed-watts]');

    var targetSelect = $('[data-upsb-rtc-target]'), ffSelect = $('[data-upsb-rtc-ff]'), protSelect = $('[data-upsb-rtc-prot]');

    var voltSelect = $('[data-upsb-rtc-volt]'), condSelect = $('[data-upsb-rtc-cond]'), brandSelect = $('[data-upsb-rtc-brand]'), sortSelect = $('[data-upsb-rtc-sort]');

    var effInput = $('[data-upsb-rtc-eff]'), effVal = $('[data-upsb-rtc-eff-val]'), ageInput = $('[data-upsb-rtc-age]'), ageVal = $('[data-upsb-rtc-age-val]');

    var summaryLoad = $('[data-upsb-rtc-summary-load]'), summaryTarget = $('[data-upsb-rtc-summary-target]'), countEl = $('[data-upsb-rtc-count]');

    var resultsEl = $('[data-upsb-rtc-results]'), emptyEl = $('[data-upsb-rtc-empty]');

    var cfgEl2 = $('[data-upsb-rtc-configured]'), cfgTitle = $('[data-upsb-rtc-configured-title]'), cfgCopy = $('[data-upsb-rtc-configured-copy]'), cfgCta = $('[data-upsb-rtc-configured-cta]');

    var quoteStrip = $('[data-upsb-rtc-quote-strip]'), quoteLink = $('[data-upsb-rtc-quote-link]');

    var shareGroup = $('[data-upsb-rtc-share]'), copyBtn = $('[data-upsb-rtc-copy]'), emailBtn = $('[data-upsb-rtc-email]'), printBtn = $('[data-upsb-rtc-print]'), addonsRail = $('[data-upsb-rtc-addons]');

    if (!amountInput || !countEl || !resultsEl) return; // markup not ready



    var ups = null, upsByHandle = {}, maxWatts = 0, loading = false, pending = false, indexFailed = false;

    var emptyOrig = emptyEl ? emptyEl.innerHTML : '';

    var builderEl = $('[data-upsb-rtc-builder]');

    state.chosenUps = '';   // handle of the UPS the user is configuring

    state.bundle = {};       // accessory handle -> qty

    state._pendingUps = '';  // from deep-link, applied after load

    state._pendingBundle = null;

    // E.19 (Claude 2026-09-27): the titles and prices on screen come from the store, not from the index. The index is
    // a theme asset that only changes when a theme is published: it still carried pre-C.24 titles and it has no French
    // titles, and prices move with the supplier sync. Stock stays from the index (quantity > 0): /products/<h>.js
    // "available" is also true for backorderable items. Rows are fetched 24 at a time; one re-render at the end, with
    // the view-only flags so an open solution builder and "show more" survive it.
    // French titles come from the index (u[18], ac[5]): /fr/products/<handle>.js is a 404 whenever the product has a
    // French handle, so the live lookups below always use the root path and only take the title on English pages.
    var isFr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
    var liveDone = {};
    function hydrate(list, changed) {
      var want = [];
      for (var i = 0; i < list.length && want.length < 24; i++) {
        var h = list[i] && list[i].handle;
        if (h && !liveDone[h] && upsByHandle[h]) { liveDone[h] = 1; want.push(h); }
      }
      if (!want.length) {
        if (changed) { state._keepBuilder = !!state.chosenUps; state._keepShown = true; update(); }
        return;
      }
      Promise.all(want.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var u = upsByHandle[h], c = false;
            if (!p || !u) return false;
            if (!isFr && p.title && p.title !== u.title) { u.title = p.title; c = true; }
            if (typeof p.price === 'number' && p.price > 0 && p.price !== u.price) { u.price = p.price; c = true; }
            return c;
          })
          .catch(function () { return false; });
      })).then(function (res) { hydrate(list, changed || res.indexOf(true) !== -1); });
    }

    function localizeInternalUrl(url) {

      if (!url || url.charAt(0) !== '/' || url.indexOf('//') === 0 || rootUrl === '/') return url;

      return url.indexOf(rootUrl) === 0 ? url : rootUrl.replace(/\/$/, '') + url;

    }

    function load(cb) {

      if (ups) { cb(); return; }

      if (loading) return;

      loading = true; countEl.textContent = '…';

      fetchIndex(cb, false);

    }

    function fetchIndex(cb, isRetry) {

      // E.15: goes through the shared cache, so a re-mount after a section
      // replacement never downloads the index twice.

      fetchIndexJson(indexUrl).then(function (j) {

        // CFG.ffLabels / CFG.tpLabels carry the French wording; upsb-ups-index.json is
        // English-only and shared across locales, so it cannot supply them.
        var ff = CFG.ffLabels || j.ff || {}, tp = CFG.tpLabels || j.tp || {}, ac = j.ac || [];

        ups = (j.u || []).map(function (r) {

          if (r[7] > maxWatts) maxWatts = r[7];

          var accessories = (r[13] || []).map(function (ix) {

            var a = ac[ix]; if (!a) return null;

            return { handle: a[0], title: (isFr && a[5]) ? a[5] : a[1], type: a[2], price: a[3], in_stock: !!a[4], url: localizeInternalUrl('/products/' + a[0]) };

          }).filter(Boolean);

          var obj = {

            handle: r[0], title: (isFr && r[18]) ? r[18] : r[1], vendor: r[2], price: r[3],

            image: r[4] ? r[4] + (r[4].indexOf('?') > -1 ? '&' : '?') + 'width=400' : '',

            in_stock: !!r[5], va: r[6], wattage: r[7], tp: r[8], ff: r[9],

            topology: tp[r[8]] || '', form_factor: ff[r[9]] || '',

            half_minutes: r[10], full_minutes: r[11], xrt: !!r[12],

            voltage: r[14] || '', plug: r[15] || '', condition: r[16] || 'N',

            url: localizeInternalUrl('/products/' + r[0]),

            accessories: accessories

          };

          upsByHandle[obj.handle] = obj;

          return obj;

        });

        if (brandSelect && brandSelect.options.length <= 1) {

          var vendors = {}; ups.forEach(function (u) { if (u.vendor) vendors[u.vendor] = 1; });

          Object.keys(vendors).sort(function (a, b) { return (vendorTier(a) - vendorTier(b)) || (a < b ? -1 : a > b ? 1 : 0); }).forEach(function (v) {

            var o = document.createElement('option'); o.value = v; o.textContent = v; brandSelect.appendChild(o);

          });

          if (state.brand) brandSelect.value = state.brand;

        }

        loading = false; indexFailed = false; cb();

      }).catch(function () {

        // E-13: retry once after 2 s, then say the list failed to load. Never fall through
        // to "No single UPS covers this load" on a fetch error.

        if (!isRetry) { setTimeout(function () { fetchIndex(cb, true); }, 2000); return; }

        ups = []; indexFailed = true; loading = false; cb();

      });

    }



    // Money (Master 2 Oct): EN as the store format "$53,707.00"; FR as snippets/upsb-money "53 707,00 $" (no-break spaces).
    function moneyCAD(c) {
      var p = (c / 100).toFixed(2).split('.');
      if (CFG.fr) return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + ',' + p[1] + '\u00a0$';
      return '$' + p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1];
    }

    function effectiveLoadW() {

      if (state.mode === 'detailed') return state.equipment.reduce(function (a, i) { return a + i.watts * i.qty; }, 0);

      var amt = state.amount;

      switch (state.unit) { case 'W': return amt; case 'kW': return amt * 1000; case 'VA': return amt * state.powerFactor; case 'kVA': return amt * 1000 * state.powerFactor; }

      return amt;

    }

    function runtimeForUPS(u, load) {

      // E-03: half-load at or below full-load is inverted source data. Treat the curve as
      // unknown (null): no interpolation, excluded from runtime filtering and runtime sort.

      if (u.half_minutes > 0 && u.full_minutes > 0 && u.half_minutes <= u.full_minutes) return null;

      var W = u.wattage; if (load > W) return 0;

      var capped = Math.max(load, W * 0.05), raw, hasHalf = u.half_minutes > 0, hasFull = u.full_minutes > 0;

      if (hasHalf && hasFull) { var b = Math.log(u.full_minutes / u.half_minutes) / Math.log(2); var a = u.full_minutes / Math.pow(W, b); raw = a * Math.pow(capped, b); }

      else if (hasHalf) { raw = u.half_minutes * (W / 2) / capped; }

      else if (hasFull) { raw = u.full_minutes * W / capped; }

      else return null; // E-20: no published runtime points; never display "~0.0 min"

      return raw * (state.efficiency / 92) * (state.batteryHealth / 100);

    }

    function isApproximate(u) { return !(u.half_minutes > 0 && u.full_minutes > 0); }

    function runtimeText(u) { return u.rt == null ? (i18n.rtNotPublished || 'Runtime not published') : (isApproximate(u) && u.rt >= 0 ? '~' : '') + formatRuntime(u.rt); }

    function formatRuntime(t) { if (t == null || t < 0) return (i18n.toConfirm || 'to confirm'); if (t >= 60) { var h = Math.floor(t / 60), m = Math.round(t - h * 60); return h + 'h ' + (m < 10 ? '0' : '') + m + 'm'; } if (t >= 10) return Math.round(t) + ' min'; return t.toFixed(1) + ' min'; }

    function formatLoad(w) { if (w >= 1000) return (w / 1000).toFixed(2).replace(/\.?0+$/, '') + ' kW'; return Math.round(w) + ' W'; }

    function protAllows(u) { if (!state.prot) return true; if (state.prot === 'max') return u.tp === 'O'; return u.tp === 'L' || u.tp === 'S'; }

    // E.16 (E-33): a rack/tower convertible unit mounts in a rack and stands as a tower, so it matches both.

    function ffAllows(u) { return !state.ff || u.ff === state.ff || (u.ff === 'C' && (state.ff === 'R' || state.ff === 'T')); }

    // E-32: a 120 V wall circuit cannot feed more than about 3 kVA, and a machine that
    // actually plugs into one carries a NEMA 5- or NEMA L5- plug. A unit passes the
    // 120 V filter only when its stored voltage is 120 (or an auto-sensing code that
    // includes 120) AND it is within the circuit's reach or carries such a plug.
    // The index builder emits "120/208" and "208/240" for auto-sensing units.

    function voltAllows(u) {

      if (!state.volt) return true;

      if (state.volt === '120') {

        var withinReach = Math.max(u.va || 0, u.wattage || 0) <= 3000;

        var wallPlug = /^NEMA (5|L5)-/i.test(u.plug || '');

        return (u.voltage === '120' || u.voltage === '120/208') && (withinReach || wallPlug);

      }

      return u.voltage === state.volt || (state.volt === '208' && (u.voltage === '120/208' || u.voltage === '208/240')) || (state.volt === '240' && u.voltage === '208/240');

    }

    function condAllows(u) { return !state.cond || u.condition === state.cond; }

    function brandAllows(u) { return !state.brand || u.vendor === state.brand; }

    function applySort(list, load) {

      if (!state.sort) return list;

      var big = 1e15;

      // E-25: explicit sorts order by their key only (in-stock first stays on the default
      // Best match sort). Unpriced units sink in both price sorts; unpublished runtimes sink
      // in the runtime sort.

      if (state.sort === 'price_asc') list.sort(function (a, b) { return (a.price > 0 ? a.price : big) - (b.price > 0 ? b.price : big); });

      else if (state.sort === 'price_desc') list.sort(function (a, b) { return (b.price > 0 ? b.price : -1) - (a.price > 0 ? a.price : -1); });

      else if (state.sort === 'runtime') list.sort(function (a, b) { return (b.rt != null ? b.rt : -1) - (a.rt != null ? a.rt : -1); });

      return list;

    }

    // E-06: every quote exit carries the model. An explicit model (a card) wins; otherwise the
    // chosen builder unit is passed. Param names match what upsb-quote-form.liquid reads
    // (handle, product). No sku: the index has none yet (E.14), so the field stays empty
    // rather than receiving a handle slug (E-14).

    function quoteUrl(load, model) {

      var p = []; if (load > 0) p.push('load=' + Math.round(load) + '%20W');

      if (state.target > 0) p.push('runtime=' + state.target);

      if (state.ff === 'T') p.push('ff=tower'); else if (state.ff === 'R') p.push('ff=rack'); else if (state.ff === 'C') p.push('ff=convertible');

      var m = model || upsByHandle[state.chosenUps];

      if (m) { p.push('handle=' + encodeURIComponent(m.handle)); p.push('product=' + encodeURIComponent((m.title || '').slice(0, 120))); }

      return quoteBase + (p.length ? '?' + p.join('&') : '');

    }

    function esc(s) { return ('' + (s || '')).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }



    function rerenderEquipment() {

      if (!equipmentList) return;

      equipmentList.innerHTML = '';

      if (!state.equipment.length) { if (detailedTotal) detailedTotal.hidden = true; return; }

      state.equipment.forEach(function (item, idx) {

        var row = document.createElement('div'); row.className = 'upsb-rtc__equipment-row';

        row.innerHTML = '<span class="upsb-rtc__equipment-name">' + esc(item.name) + '</span><span class="upsb-rtc__equipment-watts">' + item.watts + ' W × ' + item.qty + '</span><strong class="upsb-rtc__equipment-total">' + (item.watts * item.qty) + ' W</strong><button type="button" class="upsb-rtc__equipment-remove" aria-label="' + (i18n.remove || 'Remove') + '">×</button>';

        row.querySelector('.upsb-rtc__equipment-remove').addEventListener('click', function () { state.equipment.splice(idx, 1); rerenderEquipment(); update(); });

        equipmentList.appendChild(row);

      });

      if (detailedTotal) { detailedTotal.hidden = false; if (detailedWatts) detailedWatts.textContent = formatLoad(effectiveLoadW()); }

    }

    if (addBtn) addBtn.addEventListener('click', function () {

      var name = (addName.value || '').trim() || (i18n.itemDefault || 'Equipment'), watts = parseFloat(addWatts.value), qty = parseInt(addQty.value, 10) || 1;

      if (!watts || watts < 1) { addWatts.focus(); return; }

      state.equipment.push({ name: name, watts: watts, qty: qty }); addName.value = ''; addWatts.value = ''; addQty.value = 1;

      rerenderEquipment(); update(); addName.focus();

    });



    function showCfg(title, copy, load) { if (!cfgEl2) return; cfgTitle.textContent = title; cfgCopy.textContent = copy; cfgCta.href = quoteUrl(load); cfgEl2.hidden = false; }

    function clearCards() { resultsEl.querySelectorAll('.upsb-rtc__cards, .upsb-rtc__more, .upsb-rtc__table-wrap').forEach(function (n) { n.remove(); }); }



    function condLabel(c) { return c === 'R' ? (i18n.condRefurb || 'Refurbished') : (i18n.condNew || 'New'); }

    function voltLabel(v) { return v === 'HW' ? (i18n.hardwired || 'Hardwired') : (v ? v + ' V' : (i18n.toConfirm || 'to confirm')); }

    function renderTable(matches, load) {

      var wrap = document.createElement('div'); wrap.className = 'upsb-rtc__table-wrap';

      var th = [i18n.thModel || 'Model', i18n.thCondition || 'Condition', i18n.thTopology || 'Topology', i18n.thFf || 'Form factor', i18n.thVolt || 'Voltage', i18n.thPlug || 'Plug', 'W', (i18n.runtimeAt || 'Runtime at') + ' ' + Math.round(load) + ' W', i18n.thPrice || 'Price', i18n.thStock || 'Stock'];

      var html = '<table class="upsb-rtc__table"><thead><tr>' + th.map(function (h) { return '<th>' + esc(h) + '</th>'; }).join('') + '</tr></thead><tbody>';

      matches.forEach(function (u) {

        html += '<tr>' +

          '<td><a href="' + u.url + '">' + esc(u.title.slice(0, 80)) + '</a></td>' +

          '<td>' + esc(condLabel(u.condition)) + '</td>' +

          '<td>' + esc(u.topology || i18n.toConfirm || 'to confirm') + '</td>' +

          '<td>' + esc(u.form_factor || i18n.toConfirm || 'to confirm') + '</td>' +

          '<td>' + esc(voltLabel(u.voltage)) + '</td>' +

          '<td>' + esc(u.plug || i18n.toConfirm || 'to confirm') + '</td>' +

          '<td>' + u.wattage + '</td>' +

          '<td>' + runtimeText(u) + '</td>' +

          '<td>' + (u.price > 0 ? moneyCAD(u.price) : esc(i18n.quoteWord || 'Quote')) + '</td>' +

          '<td>' + (u.in_stock ? (i18n.inStock || 'In stock') : '–') + '</td>' +

        '</tr>';

      });

      html += '</tbody></table>';

      html += '<div class="upsb-rtc__table-cta"><span>' + esc(i18n.tableQuoteMsg || 'Want pricing on any of these confirmed in writing?') + '</span><a class="upsb-rtc__quote-btn" href="' + quoteUrl(load) + '">' + esc(i18n.summaryQuote || 'Get a written quote') + ' →</a></div>';

      wrap.innerHTML = html;

      resultsEl.appendChild(wrap);

    }

    function buildCsv(matches, load) {

      var head = ['model', 'handle', 'condition', 'topology', 'form_factor', 'voltage', 'plug', 'watts', 'runtime_min_at_' + Math.round(load) + 'W', 'approximate', 'price_cad', 'in_stock', 'url'];

      var rows = [head.join(',')];

      matches.forEach(function (u) {

        var cells = [u.title.replace(/"/g, "'"), u.handle, condLabel(u.condition), u.topology || '', u.form_factor || '', voltLabel(u.voltage), u.plug || '', u.wattage, (u.rt ? u.rt.toFixed(1) : ''), isApproximate(u) ? 'yes' : 'no', u.price > 0 ? (u.price / 100).toFixed(2) : '', u.in_stock ? 'yes' : 'no', 'https://upsplusbattery.ca' + u.url];

        rows.push(cells.map(function (c) { return /[",\n]/.test(String(c)) ? '"' + String(c).replace(/"/g, '""') + '"' : String(c); }).join(','));

      });

      return rows.join('\r\n');

    }



    function update() {

      // Solution builder: restore from a shared link once data is loaded, else collapse a stale builder on input change.

      if (state._pendingUps && ups && upsByHandle[state._pendingUps]) {

        state.chosenUps = state._pendingUps; state.bundle = state._pendingBundle || {};

        state._pendingUps = ''; state._pendingBundle = null; renderBuilder();

      } else if (state.chosenUps && !state._pendingUps) {

        // E-09: view-only actions (Show 12 more, Compare table, end-of-life chip) set
        // _keepBuilder so the configured solution survives their update() call.

        if (state._keepBuilder) { state._keepBuilder = false; renderBuilder(); }

        else clearBuilder();

      }

      serialize();

      var load = effectiveLoadW();

      var summaryQuoteBtn = $('[data-upsb-rtc-summary-quote]');

      if (summaryQuoteBtn) { summaryQuoteBtn.href = quoteUrl(load); summaryQuoteBtn.hidden = !(load > 0); }
      // Builder X item 16 (Master, 3 Oct 2026): carry the load, runtime, supply and form into the Solutions Builder.
      var builderLink = $('[data-upsb-rtc-builder]');
      if (builderLink) {
        builderLink.hidden = !(load > 0);
        if (load > 0) builderLink.href = builderLink.getAttribute('data-base') + '&load=' + Math.min(1000000, Math.max(50, Math.ceil(load / 50) * 50)) +
          '&runtime=' + Math.max(1, Math.min(10000, Math.round(state.target) || 10)) +
          '&power=' + (state.volt === '208' || state.volt === '240' ? '208-240' : (state.volt === '230' ? '230' : '120')) +
          '&outlet=unknown&fit=' + (state.ff === 'R' ? 'rack' : (state.ff === 'T' ? 'tower' : 'either'));
      }

      if (summaryLoad) summaryLoad.textContent = formatLoad(load);

      if (summaryTarget) summaryTarget.textContent = state.target === 0 ? (i18n.noMinimum || '–') : state.target + ' min';

      syncPresetActive();

      if (cfgEl2) cfgEl2.hidden = true; if (quoteStrip) quoteStrip.hidden = true; if (shareGroup) shareGroup.hidden = true; if (addonsRail) addonsRail.hidden = true; clearCards();



      if (load < 1) { countEl.textContent = '–'; if (emptyEl) { emptyEl.innerHTML = emptyOrig; emptyEl.hidden = false; } return; }

      if (!ups) { countEl.textContent = '…'; if (emptyEl) emptyEl.hidden = true; load_then_update(); return; }

      if (indexFailed) {

        countEl.textContent = '–';

        if (emptyEl) { emptyEl.innerHTML = '<p>' + esc(i18n.loadFail || 'The UPS list could not load. Refresh the page or call 438-881-3363.') + '</p>'; emptyEl.hidden = false; }

        return;

      }

      if (emptyEl) emptyEl.hidden = true;

      if (quoteLink) quoteLink.href = quoteUrl(load);



      var loadFits = ups.filter(function (u) { return u.wattage >= load; });

      // F21: 120 V is the starting filter (Canadian wall outlets). While the buyer has not picked a voltage,
      // fall back to Any when no 120 V unit fits, so large loads still list 208/240 V units.
      var prefOk = function (u) { return ffAllows(u) && protAllows(u) && voltAllows(u) && condAllows(u) && brandAllows(u); };
      if (state.voltAuto) { state.volt = '120'; if (voltSelect) voltSelect.value = '120'; }
      var prefFits = loadFits.filter(prefOk);
      if (state.voltAuto && !prefFits.length) { state.volt = ''; if (voltSelect) voltSelect.value = ''; prefFits = loadFits.filter(prefOk); }

      var allMatches = prefFits

        .map(function (u) { var o = {}; for (var k in u) o[k] = u[k]; o.rt = runtimeForUPS(u, load); return o; })

        .filter(function (u) { return u.rt == null ? state.target === 0 : u.rt >= state.target; })

        .sort(function (a, b) {

          // E.16: a unit at under 25 % load (more than 4x the load) goes after every in-band unit, whatever the brand.

          var aO = (load / a.wattage) < 0.25 ? 1 : 0, bO = (load / b.wattage) < 0.25 ? 1 : 0; if (aO !== bO) return aO - bO;

          // E.16: then the order groups.

          var aT = vendorTier(a.vendor), bT = vendorTier(b.vendor); if (aT !== bT) return aT - bT;

          var aS = a.in_stock ? 0 : 1, bS = b.in_stock ? 0 : 1; if (aS !== bS) return aS - bS;

          var aR = load / a.wattage, bR = load / b.wattage;

          var aF = (aR >= 0.5 && aR <= 0.85) ? 0 : Math.abs(aR - 0.7);

          var bF = (bR >= 0.5 && bR <= 0.85) ? 0 : Math.abs(bR - 0.7);

          return aF - bF;

        });

      allMatches = applySort(allMatches, load);

      lastAll = allMatches; lastLoad = load;

      if (!state._keepShown) state.shown = 12;

      state._keepShown = false;

      var matches = allMatches.slice(0, state.shown);



      countEl.textContent = allMatches.length;



      if (loadFits.length === 0) { showCfg(i18n.cfgOversizeTitle, i18n.cfgOversizeCopy, load); return; }

      if (matches.length > 0) {

        if (state._view === 'table') { renderTable(allMatches.slice(0, 100), load); hydrate(allMatches.slice(0, 100), false); }

        else { renderCards(matches, load); renderMoreFooter(allMatches, matches); hydrate(matches, false); }

        if (quoteStrip) quoteStrip.hidden = false;

        if (shareGroup) shareGroup.hidden = false;

        if (addonsRail) addonsRail.hidden = false;

        if (load >= 10000) showCfg(i18n.largeAdvisoryTitle, i18n.largeAdvisoryCopy, load);

        return;

      }

      if (prefFits.length === 0) { showCfg(i18n.cfgNoneTitle, i18n.cfgNoneCopy, load); return; }

      showCfg(i18n.cfgRuntimeTitle, i18n.cfgRuntimeCopy, load);

    }



    function renderCards(matches, load) {

      var grid = document.createElement('div'); grid.className = 'upsb-rtc__cards';

      matches.forEach(function (u, idx) {

        var pct = Math.round((load / u.wattage) * 100), buy = u.in_stock && u.price > 0, href = buy ? u.url : quoteUrl(load, u);

        var badges = '';

        if (u.condition === 'R') badges += '<span class="upsb-rtc__badge upsb-rtc__badge--refurb">' + esc(i18n.condRefurb || 'Refurbished') + '</span>';

        if (u.voltage) badges += '<span class="upsb-rtc__badge">' + (u.voltage === 'HW' ? esc(i18n.hardwired || 'Hardwired') : esc(u.voltage) + ' V') + '</span>';

        if (u.plug) badges += '<span class="upsb-rtc__badge">' + esc(i18n.thPlug || 'Plug') + ': ' + esc(u.plug) + '</span>';

        if (u.xrt) badges += '<span class="upsb-rtc__badge upsb-rtc__badge--xrt">' + esc(i18n.xrtBadge || 'Extends with EBMs') + '</span>';

        var card = document.createElement('a'); card.className = 'upsb-rtc__card'; card.href = href;

        card.innerHTML =

          '<div class="upsb-rtc__card-img">' + (u.image ? '<img src="' + u.image + '" alt="" loading="lazy">' : '') + '</div>' +

          '<div class="upsb-rtc__card-body">' +

            '<div class="upsb-rtc__card-vendor">' + esc(u.vendor || '') + (u.in_stock ? ' · <span class="upsb-rtc__instock">' + (i18n.inStock || 'In stock') + '</span>' : '') + '</div>' +

            '<h4 class="upsb-rtc__card-title">' + esc(u.title) + '</h4>' +

            '<div class="upsb-rtc__card-meta"><span><strong>' + u.wattage + ' W</strong> ' + (i18n.capacity || '') + '</span>' + (u.topology ? '<span>' + esc(u.topology) + '</span>' : '') + (u.form_factor ? '<span>' + esc(u.form_factor) + '</span>' : '') + '</div>' +

            (badges ? '<div class="upsb-rtc__badges">' + badges + '</div>' : '') +

            '<div class="upsb-rtc__card-rt"><span class="upsb-rtc__card-rt-label">' + (i18n.runtimeAt || '') + ' ' + Math.round(load) + ' W</span><span class="upsb-rtc__card-rt-value">' + runtimeText(u) + '</span><span class="upsb-rtc__card-rt-pct">' + pct + '% ' + (i18n.loaded || '') + (u.rt != null && isApproximate(u) ? ' · ' + (i18n.approximate || '') : '') + '</span></div>' +

            '<div class="upsb-rtc__util" aria-hidden="true"><span class="upsb-rtc__util-zone"></span><span class="upsb-rtc__util-mark" style="left:' + Math.min(pct, 100) + '%"></span></div>' +

            '<div class="upsb-rtc__card-foot"><span class="upsb-rtc__card-price">' + (u.price > 0 ? moneyCAD(u.price) : esc(i18n.quoteWord || 'Quote')) + '</span><span class="upsb-rtc__card-cta">' + (buy ? (i18n.view || 'View') + ' →' : (i18n.checkAvail || 'Check availability →')) + '</span></div>' +

          '</div>';

        var sOn = state.chosenUps === u.handle;

        var wrap = document.createElement('div'); wrap.className = 'upsb-rtc__card-wrap' + (sOn ? ' is-selected' : '');

        if (idx === 0 && matches.length > 1) { var bm = document.createElement('span'); bm.className = 'upsb-rtc__bestmatch'; bm.textContent = i18n.bestMatch || 'Best match'; wrap.appendChild(bm); }

        wrap.appendChild(card);

        var sel = document.createElement('button');

        sel.type = 'button'; sel.className = 'upsb-rtc__card-select'; sel.setAttribute('data-upsb-build', u.handle);

        sel.setAttribute('aria-pressed', sOn ? 'true' : 'false');

        sel.innerHTML = '<span class="upsb-rtc__card-select-box" aria-hidden="true"></span><span class="upsb-rtc__card-select-label">' + esc(sOn ? (i18n.inQuote || 'In your quote') : (i18n.addToQuote || 'Add to quote')) + '</span>';

        wrap.appendChild(sel);

        grid.appendChild(wrap);

      });

      resultsEl.appendChild(grid);

    }



    var SHOW_CAP = 48;

    function renderMoreFooter(allMatches, shownMatches) {

      if (allMatches.length <= shownMatches.length && allMatches.length <= 12) return;

      var stockN = 0;

      for (var i = 0; i < allMatches.length; i++) if (allMatches[i].in_stock) stockN++;

      var foot = document.createElement('div'); foot.className = 'upsb-rtc__more';

      var msg = (i18n.matchesOf || 'Showing the [shown] best fits of [total] matching UPS, [stock] in stock')

        .replace('[shown]', shownMatches.length).replace('[total]', allMatches.length).replace('[stock]', stockN);

      var html = '<span class="upsb-rtc__more-msg">' + esc(msg) + '</span>';

      if (allMatches.length > shownMatches.length && state.shown < SHOW_CAP) {

        html += '<button type="button" class="upsb-rtc__share-btn upsb-rtc__more-btn" data-upsb-rtc-more>' + esc(i18n.showMore || 'Show 12 more') + '</button>';

      }

      foot.innerHTML = html;

      var btn = foot.querySelector('[data-upsb-rtc-more]');

      if (btn) btn.addEventListener('click', function () { state.shown = Math.min(state.shown + 12, SHOW_CAP); state._keepShown = true; state._keepBuilder = true; update(); });

      resultsEl.appendChild(foot);

    }



    // ── Solution builder (Phase 3) ──────────────────────────────

    var GROUPS = [

      { key: 'runtime',    label: i18n.grpRuntime    || 'Extend runtime',     types: ['Extended Battery Modules'] },

      { key: 'monitoring', label: i18n.grpMonitoring || 'Remote monitoring',  types: ['Network Cards', 'Monitoring & Sensors'] },

      { key: 'mounting',   label: i18n.grpMounting   || 'Rack mounting',      types: ['Rail & Mounting Kits'] },

      { key: 'bypass',     label: i18n.grpBypass     || 'Switching & bypass', types: ['Transfer Switches'] },

      { key: 'power',      label: i18n.grpPower      || 'Power distribution', types: ['Rack PDUs', 'Power Cords & Whips'] },

      { key: 'cooling',    label: i18n.grpCooling    || 'Cooling & airflow',  types: ['Cooling & Airflow'] }

    ];

    function groupFor(type) { for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].types.indexOf(type) > -1) return GROUPS[i].key; return 'other'; }

    function accByHandle(u, h) { for (var i = 0; i < u.accessories.length; i++) if (u.accessories[i].handle === h) return u.accessories[i]; return null; }

    function bundleTotal(u) {

      var cents = 0, quoteItems = 0;

      if (u.price > 0) cents += u.price; else quoteItems++;

      Object.keys(state.bundle).forEach(function (h) { var q = state.bundle[h]; if (q < 1) return; var a = accByHandle(u, h); if (!a) return; if (a.price > 0) cents += a.price * q; else quoteItems++; });

      return { cents: cents, quoteItems: quoteItems };

    }

    function setBuildButtons() {

      $$('[data-upsb-build]').forEach(function (b) {

        var on = b.getAttribute('data-upsb-build') === state.chosenUps;

        b.setAttribute('aria-pressed', String(on));

        var lbl = b.querySelector('.upsb-rtc__card-select-label'); if (lbl) lbl.textContent = on ? (i18n.inQuote || 'In your quote') : (i18n.addToQuote || 'Add to quote');

        var wr = b.closest ? b.closest('.upsb-rtc__card-wrap') : null; if (wr) wr.classList.toggle('is-selected', on);

      });

    }

    function pickUps(handle) {

      var u = upsByHandle[handle]; if (!u) return;

      if (state.chosenUps !== handle) { state.chosenUps = handle; state.bundle = {}; }

      renderBuilder(); setBuildButtons(); serializeNow();

      if (builderEl && builderEl.scrollIntoView) builderEl.scrollIntoView({ behavior: 'smooth', block: 'start' });

    }

    function clearBuilder() { state.chosenUps = ''; state.bundle = {}; if (builderEl) { builderEl.hidden = true; builderEl.innerHTML = ''; } setBuildButtons(); }

    function bundleQuoteUrl(u) {

      var lines = [], hasEbm = false, hasNmc = false, hasByp = false;

      lines.push('UPS: ' + u.title + ' (' + u.handle + ')');

      Object.keys(state.bundle).forEach(function (h) {

        var q = state.bundle[h]; if (q < 1) return; var a = accByHandle(u, h); if (!a) return;

        lines.push(q + 'x ' + a.title + ' (' + a.handle + ')');

        if (a.type === 'Extended Battery Modules') hasEbm = true;

        if (a.type === 'Network Cards') hasNmc = true;

        if (a.type === 'Transfer Switches') hasByp = true;

      });

      var t = bundleTotal(u);

      if (t.cents > 0) lines.push((i18n.estTotal || 'Estimated total') + ': ' + moneyCAD(t.cents) + (t.quoteItems ? ' + quote items' : ''));

      var p = ['config=' + encodeURIComponent(lines.join('\n')), 'handle=' + encodeURIComponent(u.handle)];

      p.push('product=' + encodeURIComponent((u.title || '').slice(0, 120)));

      var load = effectiveLoadW(); if (load > 0) p.push('load=' + Math.round(load) + '%20W');

      if (state.target > 0) p.push('runtime=' + state.target);

      var ffq = u.ff === 'T' ? 'tower' : u.ff === 'R' ? 'rack' : u.ff === 'C' ? 'convertible' : '';

      if (ffq) p.push('ff=' + ffq);

      if (hasEbm) p.push('xbp=1');

      if (u.xrt) p.push('xrt=1');

      if (hasNmc) p.push('nmc=1');

      if (hasByp) p.push('byp=1');

      return quoteBase + '?' + p.join('&');

    }

    function renderBundleSummary() {

      var box = builderEl && builderEl.querySelector('[data-upsb-bundle-summary]'); if (!box) return;

      var u = upsByHandle[state.chosenUps]; if (!u) return;

      var lines = ['<li><span>' + esc(u.title) + '</span><span>' + (u.price > 0 ? moneyCAD(u.price) : esc(i18n.quoteWord || 'Quote')) + '</span></li>'];

      var hasEbmSel = false;

      Object.keys(state.bundle).forEach(function (h) { var q = state.bundle[h]; if (q < 1) return; var a = accByHandle(u, h); if (!a) return; if (a.type === 'Extended Battery Modules') hasEbmSel = true; lines.push('<li><span>' + q + '× ' + esc(a.title) + '</span><span>' + (a.price > 0 ? moneyCAD(a.price * q) : esc(i18n.quoteWord || 'Quote')) + '</span></li>'); });

      var t = bundleTotal(u);

      var totalStr = moneyCAD(t.cents) + (t.quoteItems ? ' <span class="upsb-rtc__bundle-plus">' + esc(i18n.quoteItems || '+ items priced on quote') + '</span>' : '');

      box.innerHTML =

        '<h4 class="upsb-rtc__bundle-h">' + esc(i18n.bundleTitle || 'Your solution') + '</h4>' +

        '<ul class="upsb-rtc__bundle-list">' + lines.join('') + '</ul>' +

        '<div class="upsb-rtc__bundle-total"><span>' + esc(i18n.bundleTotal || 'Estimated total') + '</span><strong>' + totalStr + '</strong></div>' +

        (hasEbmSel ? '<p class="upsb-rtc__bundle-note upsb-rtc__bundle-ebm">' + esc(i18n.ebmWhatIf || 'With external battery modules: typically 2 to 3× the base runtime. We confirm the exact figure in your quote.') + '</p>' : '') +

        '<a class="upsb-btn upsb-btn--primary upsb-rtc__bundle-quote" href="' + bundleQuoteUrl(u) + '">' + esc(i18n.requestQuoteBundle || 'Request a quote for this solution') + ' →</a>' +

        '<p class="upsb-rtc__bundle-promise">' + esc(i18n.quotePromise || 'Written reply within 1 business day, no obligation.') + '</p>' +

        '<p class="upsb-rtc__bundle-call">' + esc(i18n.preferTalk || 'Prefer to talk?') + ' <a href="tel:+14388813363">438-881-3363</a></p>' +

        '<p class="upsb-rtc__bundle-note">' + esc(i18n.bundleNote || 'Estimates in CAD. We confirm final pricing, stock and compatibility in your quote.') + '</p>';

    }

    function renderBuilder() {

      if (!builderEl) return;

      var u = upsByHandle[state.chosenUps];

      if (!u) { builderEl.hidden = true; builderEl.innerHTML = ''; return; }

      var byGroup = {};

      u.accessories.forEach(function (a) { var g = groupFor(a.type); (byGroup[g] = byGroup[g] || []).push(a); });

      var labelFor = { other: i18n.grpOther || 'Other accessories' }; GROUPS.forEach(function (g) { labelFor[g.key] = g.label; });

      var order = GROUPS.map(function (g) { return g.key; }).concat(['other']);

      var html = '<div class="upsb-rtc__builder-inner">' +

        '<div class="upsb-rtc__builder-head"><span class="upsb-pdp__eyebrow">' + esc(i18n.builderEyebrow || 'Build your solution') + '</span>' +

        '<button type="button" class="upsb-rtc__builder-change" data-upsb-build-clear>' + esc(i18n.changeUps || '← Change UPS') + '</button></div>' +

        '<div class="upsb-rtc__bundle-base"><div class="upsb-rtc__bundle-thumb">' + (u.image ? '<img src="' + u.image + '" alt="" loading="lazy">' : '') + '</div>' +

        '<div class="upsb-rtc__bundle-base-txt"><span class="upsb-rtc__bundle-tag">' + esc(i18n.baseUnit || 'Base unit') + '</span><strong>' + esc(u.title) + '</strong></div>' +

        '<span class="upsb-rtc__bundle-base-price">' + (u.price > 0 ? moneyCAD(u.price) : esc(i18n.quoteWord || 'Quote')) + '</span></div>' +

        '<div class="upsb-rtc__builder-grid"><div class="upsb-rtc__builder-main"><div class="upsb-rtc__builder-groups">';

      function accModel(title) {

        var m = (title || '').match(/\b([A-Z][A-Z0-9][A-Z0-9-]{2,}\d[A-Z0-9-]*)\b/);

        return m ? m[1] : '';

      }

      order.forEach(function (gk) {

        var list = byGroup[gk];

        if ((!list || !list.length) && gk === 'mounting' && (u.ff === 'R' || u.ff === 'C')) {

          // Rackmount unit with no model-matched rails in compat data: offer the rails collection (no compat claims).

          html += '<div class="upsb-rtc__builder-group"><h4 class="upsb-rtc__builder-group-h">' + esc(labelFor[gk]) + '</h4>' +

            '<a class="upsb-rtc__acc-link" href="' + localizeInternalUrl('/collections/ups-rack-mounting-kits') + '" target="_blank" rel="noopener">' + esc(i18n.railsBrowse || 'Browse rack & mounting kits →') + '</a></div>';

          return;

        }

        if (!list || !list.length) return;

        html += '<div class="upsb-rtc__builder-group"><h4 class="upsb-rtc__builder-group-h">' + esc(labelFor[gk]) + '</h4>';

        list.forEach(function (a) {

          var q = state.bundle[a.handle] || 0, on = q > 0;

          var model = accModel(a.title);

          var nameHtml = model ? '<span class="upsb-rtc__acc-sku">' + esc(model) + '</span> ' + esc(a.title.replace(model, '').replace(/\s*-\s*$/, '').replace(/^\s*-\s*/, '').replace(/\s{2,}/g, ' ').trim()) : esc(a.title);

          html += '<label class="upsb-rtc__acc-opt' + (on ? ' is-on' : '') + '">' +

            '<input type="checkbox" class="upsb-rtc__acc-check" data-upsb-acc="' + esc(a.handle) + '"' + (on ? ' checked' : '') + '>' +

            '<span class="upsb-rtc__acc-name">' + nameHtml + (a.in_stock ? ' <span class="upsb-rtc__acc-stock">' + esc(i18n.inStock || 'In stock') + '</span>' : '') + '</span>' +

            '<span class="upsb-rtc__acc-price">' + (a.price > 0 ? moneyCAD(a.price) : esc(i18n.quoteWord || 'Quote')) + '</span>' +

            '<span class="upsb-rtc__acc-qty"' + (on ? '' : ' hidden') + '>' + esc(i18n.qty || 'Qty') + ' <input type="number" min="1" step="1" value="' + (q || 1) + '" data-upsb-acc-qty="' + esc(a.handle) + '" aria-label="' + esc(i18n.qty || 'Qty') + '"></span>' +

            '</label>';

        });

        html += '</div>';

      });

      html += '</div>' + (u.accessories.length ? '' : '<p class="upsb-rtc__builder-noaddons">' + esc(i18n.noAddons || 'No add-on options are listed for this model. We’ll confirm available options in your quote.') + '</p>') + '</div><aside class="upsb-rtc__builder-aside"><div class="upsb-rtc__bundle-summary" data-upsb-bundle-summary></div></aside></div></div>';

      builderEl.innerHTML = html; builderEl.hidden = false;

      renderBundleSummary();

    }

    root.addEventListener('click', function (e) {

      var t = e.target;

      var bb = t.closest ? t.closest('[data-upsb-build]') : null;

      if (bb) { e.preventDefault(); var bh = bb.getAttribute('data-upsb-build'); if (state.chosenUps === bh) { clearBuilder(); serializeNow(); } else { pickUps(bh); } return; }

      if (t.closest && t.closest('[data-upsb-build-clear]')) { clearBuilder(); serializeNow(); return; }

    });

    root.addEventListener('change', function (e) {

      var cb = e.target.closest ? e.target.closest('[data-upsb-acc]') : null; if (!cb) return;

      var h = cb.getAttribute('data-upsb-acc');

      if (cb.checked) { if (!(state.bundle[h] > 0)) state.bundle[h] = 1; } else { delete state.bundle[h]; }

      var lbl = cb.closest('.upsb-rtc__acc-opt'); if (lbl) { lbl.classList.toggle('is-on', cb.checked); var qe = lbl.querySelector('.upsb-rtc__acc-qty'); if (qe) qe.hidden = !cb.checked; }

      renderBundleSummary(); serializeNow();

    });

    root.addEventListener('input', function (e) {

      var qi = e.target.closest ? e.target.closest('[data-upsb-acc-qty]') : null; if (!qi) return;

      var q = parseInt(qi.value, 10) || 1; if (q < 1) q = 1; state.bundle[qi.getAttribute('data-upsb-acc-qty')] = q;

      renderBundleSummary(); serializeNow();

    });



    function load_then_update() { if (pending) return; pending = true; load(function () { pending = false; update(); }); }



    modeTabs.forEach(function (tab) { tab.addEventListener('click', function () {

      state.mode = tab.dataset.upsbRtcMode;

      modeTabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });

      panes.forEach(function (p) { var on = p.dataset.upsbRtcPane === state.mode; p.classList.toggle('is-active', on); p.hidden = !on; });

      update();

    }); });

    amountInput.addEventListener('input', function (e) { state.amount = parseFloat(e.target.value) || 0; update(); });

    var presetBtns = $$('[data-upsb-rtc-preset]');

    function syncPresetActive() { presetBtns.forEach(function (b) { var v = parseFloat(b.getAttribute('data-upsb-rtc-preset')); b.classList.toggle('is-active', state.mode === 'simple' && state.unit === 'W' && Math.round(state.amount) === v); }); }

    presetBtns.forEach(function (b) { b.addEventListener('click', function () {

      var v = parseFloat(b.getAttribute('data-upsb-rtc-preset')) || 0; if (!v) return;

      state.amount = v; state.unit = 'W';

      if (amountInput) amountInput.value = v;

      if (unitSelect) unitSelect.value = 'W';

      if (pfRow) pfRow.hidden = true;

      var simpleTab = null; modeTabs.forEach(function (t) { if (t.dataset.upsbRtcMode === 'simple') simpleTab = t; });

      if (state.mode !== 'simple' && simpleTab) simpleTab.click(); else update();

    }); });

    if (unitSelect) unitSelect.addEventListener('change', function (e) { state.unit = e.target.value; if (pfRow) pfRow.hidden = !(state.unit === 'VA' || state.unit === 'kVA'); update(); });

    if (pfInput) pfInput.addEventListener('input', function (e) { state.powerFactor = parseFloat(e.target.value); if (pfDisplay) pfDisplay.textContent = state.powerFactor.toFixed(2); update(); });

    if (targetSelect) targetSelect.addEventListener('change', function (e) { state.target = parseInt(e.target.value, 10) || 0; update(); });

    if (ffSelect) ffSelect.addEventListener('change', function (e) { state.ff = e.target.value; update(); });

    if (protSelect) protSelect.addEventListener('change', function (e) { state.prot = e.target.value; update(); });

    if (voltSelect) voltSelect.addEventListener('change', function (e) { state.volt = e.target.value; state.voltAuto = false; update(); });

    if (condSelect) condSelect.addEventListener('change', function (e) { state.cond = e.target.value; update(); });

    if (brandSelect) brandSelect.addEventListener('change', function (e) { state.brand = e.target.value; update(); });

    if (sortSelect) sortSelect.addEventListener('change', function (e) { state.sort = e.target.value; update(); });

    if (effInput) effInput.addEventListener('input', function (e) { state.efficiency = parseInt(e.target.value, 10); if (effVal) effVal.textContent = state.efficiency; update(); });

    if (ageInput) ageInput.addEventListener('input', function (e) { state.batteryHealth = parseInt(e.target.value, 10); if (ageVal) ageVal.textContent = state.batteryHealth; update(); });



    // ── Deep-link state (Part C1): URL <-> inputs ──

    var shareTimer = null;

    function serializeNow() {

      try {

        var p = new URLSearchParams();

        if (state.mode === 'detailed') {

          p.set('mode', 'detailed');

          if (state.equipment.length) p.set('eq', state.equipment.map(function (it) { return encodeURIComponent(it.name) + ':' + it.watts + ':' + it.qty; }).join(','));

        } else {

          p.set('load', Math.round(state.amount));

          if (state.unit !== 'W') p.set('u', state.unit);

          if (state.unit === 'VA' || state.unit === 'kVA') p.set('pf', state.powerFactor);

        }

        p.set('rt', state.target);

        if (state.efficiency !== 92) p.set('eff', state.efficiency);

        if (state.batteryHealth !== 100) p.set('age', state.batteryHealth);

        if (state.ff) p.set('ff', state.ff);

        if (state.prot) p.set('prot', state.prot);

        if (!state.voltAuto) p.set('v', state.volt || 'any');

        if (state.cond) p.set('cond', state.cond);

        if (state.brand) p.set('brand', state.brand);

        if (state.sort) p.set('sort', state.sort);

        if (state.chosenUps) {

          p.set('ups', state.chosenUps);

          var adds = Object.keys(state.bundle).filter(function (h) { return state.bundle[h] > 0; });

          if (adds.length) p.set('add', adds.map(function (h) { return h + ':' + state.bundle[h]; }).join(','));

        }

        var qs = p.toString();

        window.history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);

      } catch (e) {}

    }

    function serialize() { if (shareTimer) clearTimeout(shareTimer); shareTimer = setTimeout(serializeNow, 250); }



    function applyDeepLink() {

      try {

        var q = new URLSearchParams(window.location.search);

        var ld = parseFloat(q.get('load'));

        if (ld > 0) { state.amount = ld; amountInput.value = ld; }

        var u = (q.get('u') || '').trim();

        if (u && unitSelect && ['W', 'kW', 'VA', 'kVA'].indexOf(u) > -1) { state.unit = u; unitSelect.value = u; if (pfRow) pfRow.hidden = !(u === 'VA' || u === 'kVA'); }

        var pf = parseFloat(q.get('pf'));

        if (pf >= 0.5 && pf <= 1) { state.powerFactor = pf; if (pfInput) pfInput.value = pf; if (pfDisplay) pfDisplay.textContent = pf.toFixed(2); }

        var rtRaw = q.get('rt'); if (rtRaw === null) rtRaw = q.get('runtime');

        var rt = parseInt(rtRaw, 10);

        if (rt >= 0 && targetSelect) {

          var avail = [0, 5, 10, 15, 20, 30, 60], snap = 0;

          for (var i = 0; i < avail.length; i++) { if (rt >= avail[i]) snap = avail[i]; }

          state.target = snap; targetSelect.value = String(snap);

        }

        var eff = parseInt(q.get('eff'), 10);

        if (eff >= 80 && eff <= 98 && effInput) { state.efficiency = eff; effInput.value = eff; if (effVal) effVal.textContent = eff; }

        var age = parseInt(q.get('age'), 10);

        if (age >= 50 && age <= 100 && ageInput) { state.batteryHealth = age; ageInput.value = age; if (ageVal) ageVal.textContent = age; }

        var ffParam = (q.get('ff') || '').toLowerCase();

        if (ffParam && ffSelect) {

          var ffMap = { tower: 'T', t: 'T', rack: 'R', r: 'R', rackmount: 'R', convertible: 'C', c: 'C', 'rack/tower': 'C' };

          var fv = ffMap[ffParam]; if (fv) { state.ff = fv; ffSelect.value = fv; }

        }

        var prot = (q.get('prot') || '').toLowerCase();

        if ((prot === 'standard' || prot === 'max') && protSelect) { state.prot = prot; protSelect.value = prot; }

        var volt = (q.get('v') || '').toUpperCase();

        if (['120', '208', '240', 'HW'].indexOf(volt) > -1 && voltSelect) { state.volt = volt; state.voltAuto = false; voltSelect.value = volt; }

        else if (volt === 'ANY' && voltSelect) { state.volt = ''; state.voltAuto = false; voltSelect.value = ''; }

        var cond = (q.get('cond') || '').toUpperCase();

        if ((cond === 'N' || cond === 'R') && condSelect) { state.cond = cond; condSelect.value = cond; }

        var brand = q.get('brand') || '';

        if (brand) { state.brand = brand; if (brandSelect) brandSelect.value = brand; }

        var srt = (q.get('sort') || '').toLowerCase();

        if (['price_asc', 'price_desc', 'runtime'].indexOf(srt) > -1 && sortSelect) { state.sort = srt; sortSelect.value = srt; }

        var mode = (q.get('mode') || '').toLowerCase();

        if ((mode === 'detailed' || mode === 'simple') && modeTabs.length) {

          state.mode = mode;

          modeTabs.forEach(function (t) { var on = t.dataset.upsbRtcMode === mode; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });

          panes.forEach(function (pp) { var on = pp.dataset.upsbRtcPane === mode; pp.classList.toggle('is-active', on); pp.hidden = !on; });

        }

        var eq = q.get('eq');

        if (eq) {

          eq.split(',').forEach(function (chunk) {

            var parts = chunk.split(':');

            if (parts.length >= 2) {

              var w = parseFloat(parts[1]); var qy = parseInt(parts[2], 10) || 1;

              var nm = (decodeURIComponent(parts[0] || '') || '').trim() || (i18n.itemDefault || 'Equipment');

              if (w > 0) state.equipment.push({ name: nm, watts: w, qty: qy });

            }

          });

          if (state.equipment.length) rerenderEquipment();

        }

        var upsParam = (q.get('ups') || '').trim();

        if (upsParam) {

          state._pendingUps = upsParam;

          var bundle = {}, addParam = q.get('add');

          if (addParam) addParam.split(',').forEach(function (chunk) { var parts = chunk.split(':'); var h = (parts[0] || '').trim(); var qy = parseInt(parts[1], 10) || 1; if (h) bundle[h] = qy < 1 ? 1 : qy; });

          state._pendingBundle = bundle;

        }

      } catch (e) {}

    }



    // ── Share / Email / Print / Copy-summary ──

    var copysumBtn = $('[data-upsb-rtc-copysum]');

    function readTopMatches(n) {

      var cards = resultsEl.querySelectorAll('.upsb-rtc__cards .upsb-rtc__card-wrap'), out = [];

      for (var i = 0; i < cards.length && out.length < n; i++) {

        var c = cards[i];

        var title = ((c.querySelector('.upsb-rtc__card-title') || {}).textContent || '').trim();

        var rt = ((c.querySelector('.upsb-rtc__card-rt-value') || {}).textContent || '').trim();

        var price = ((c.querySelector('.upsb-rtc__card-price') || {}).textContent || '').trim();

        if (title) out.push({ title: title, rt: rt, price: price });

      }

      return out;

    }

    function buildSummaryText() {

      var load = effectiveLoadW(), lines = [];

      lines.push(i18n.summaryHeading || 'UPS sizing · UPSPLUSBATTERY.CA');

      lines.push((i18n.emailLoad || 'Load') + ': ' + formatLoad(load) + '  ·  ' + (i18n.emailTarget || 'Target runtime') + ': ' + (state.target ? state.target + ' min' : '–'));

      var top = readTopMatches(3);

      if (top.length) {

        lines.push(''); lines.push((i18n.summaryTopLabel || 'Top matches') + ':');

        top.forEach(function (m, i) { lines.push((i + 1) + '. ' + m.title + (m.rt ? ', ' + m.rt : '') + (m.price ? ', ' + m.price : '')); });

      }

      lines.push(''); lines.push(window.location.href);

      return lines.join('\n');

    }

    function flashBtn(btn, msg) { if (!btn) return; var orig = btn.getAttribute('data-label') || btn.textContent; btn.textContent = msg; setTimeout(function () { btn.textContent = orig; }, 1600); }

    function copyText(text, onDone) {

      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(onDone).catch(onDone);

      else { try { var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px'; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); onDone(); } catch (e) {} }

    }

    var cmpBtn = $('[data-upsb-rtc-cmp]'), csvBtn = $('[data-upsb-rtc-csv]'), eolBtn = $('[data-upsb-rtc-eol]');

    if (cmpBtn) cmpBtn.addEventListener('click', function () {

      state._view = state._view === 'table' ? 'cards' : 'table';

      cmpBtn.textContent = state._view === 'table' ? (i18n.cardView || 'Card view') : (i18n.compareView || 'Compare table');

      cmpBtn.setAttribute('aria-pressed', String(state._view === 'table'));

      state._keepBuilder = true; update();

    });

    if (csvBtn) csvBtn.addEventListener('click', function () {

      if (!lastAll.length) return;

      var blob = new Blob([buildCsv(lastAll.slice(0, 500), lastLoad)], { type: 'text/csv;charset=utf-8' });

      var a = document.createElement('a'); a.href = URL.createObjectURL(blob);

      a.download = 'ups-sizing-' + Math.round(lastLoad) + 'W.csv'; document.body.appendChild(a); a.click();

      setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 800);

    });

    if (eolBtn) eolBtn.addEventListener('click', function () {

      var on = state.batteryHealth !== 80;

      state.batteryHealth = on ? 80 : 100;

      if (ageInput) ageInput.value = state.batteryHealth;

      if (ageVal) ageVal.textContent = state.batteryHealth;

      eolBtn.classList.toggle('is-active', on);

      eolBtn.setAttribute('aria-pressed', String(on));

      state._keepBuilder = true; update();

    });

    if (copyBtn) copyBtn.addEventListener('click', function () { copyText(window.location.href, function () { flashBtn(copyBtn, i18n.copied || 'Link copied'); }); });

    if (copysumBtn) copysumBtn.addEventListener('click', function () { copyText(buildSummaryText(), function () { flashBtn(copysumBtn, i18n.copySummaryDone || 'Summary copied'); }); });

    if (emailBtn) emailBtn.addEventListener('click', function (e) { e.preventDefault(); window.location.href = 'mailto:info@upsplusbattery.com?subject=' + encodeURIComponent(i18n.emailSubject || 'UPS sizing results') + '&body=' + encodeURIComponent(buildSummaryText()); });

    if (printBtn) printBtn.addEventListener('click', function () { var pe = root.querySelector('[data-upsb-rtc-printurl]'); if (pe) pe.textContent = window.location.href; window.print(); });



    applyDeepLink();

    if (summaryLoad) summaryLoad.textContent = formatLoad(effectiveLoadW());

    if (summaryTarget) summaryTarget.textContent = state.target + ' min';

    load_then_update();

  }



  function mountAll() {

    var roots = document.querySelectorAll('[data-upsb-rtc]');

    for (var i = 0; i < roots.length; i++) mount(roots[i]);

    // E.16: watch for section replacement only on pages that have a calculator (this script loads sitewide).

    if (roots.length) watchForReplacement();

  }

  // E.15: a section replacement (outerHTML swap by the FR cache-recovery guard or
  // section rendering) leaves a fresh [data-upsb-rtc] root that this script has
  // already finished retrying. Watch for it and mount whatever new roots appear.
  // mount() is idempotent, so firing on unrelated mutations is harmless.

  var watching = false;

  function watchForReplacement() {

    if (watching || typeof MutationObserver !== 'function' || !document.body) return;

    watching = true;

    var scheduled = false;

    var obs = new MutationObserver(function () {

      if (scheduled) return;

      scheduled = true;

      window.requestAnimationFrame(function () { scheduled = false; mountAll(); });

    });

    obs.observe(document.body, { childList: true, subtree: true });

  }

  function boot() {

    mountAll();

    // Retry: the section may be injected via innerHTML slightly after load (FR cache-recovery).

    var tries = 0;

    var iv = setInterval(function () { mountAll(); if (++tries >= 8 || (document.querySelector('[data-upsb-rtc]') && document.querySelector('[data-upsb-rtc]').__rtcMounted)) clearInterval(iv); }, 400);

    window.addEventListener('load', mountAll);

  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);

  else boot();

})();

